<template>
   <div class="aoe-loader">
    <div class="overlay-container" v-if="isLoading">
      <kLoader type="infinite-spinner" :size="'large'" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { Loader as kLoader } from '@progress/kendo-vue-indicators'
import logger from '@/logger.ts'
import { ref  } from 'vue'
import type { AoeMessageEvent } from '@/types/AoeTypes.ts'
const isLoading = ref(false)
logger.debug('AoeLoader', 'AoeLoader.vue')

window.addEventListener('message', messagehandler)

async function messagehandler(e: AoeMessageEvent) {
  logger.debug('AoeLoader', 'messagehandler', e)
  const allowedOrigin = `${window.location.protocol}//${window.location.hostname}`
  if (!e.origin.startsWith(allowedOrigin)) {
    logger.debug(
      'AoeLoader',
      'messagehandler',
      'origin not allowed',
      e.origin,
      allowedOrigin,
    )
    return
  }
  if (e.data && e.data.messageType === 'aoeloading') {
    logger.debug(
      'AoeLoader',
      'messagehandler',
      'aoeloading',
    )
    isLoading.value = true
  }
  if (e.data && e.data.messageType === 'aoeloaded') {
    logger.debug(
      'AoeLoader',
      'messagehandler',
      'aoeloaded',
    )
    isLoading.value = false
  }
}

</script>

<style lang="scss">
.overlay-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(black, 0.5);
  z-index: $z-modal-backdrop;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
